"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelephonyProvider = void 0;
exports.TelephonyProvider = {
    Twilio: "twilio",
    SipTrunk: "sip_trunk",
};
